import { render } from "./VartaBlue.vue?vue&type=template&id=d120f2ce&scoped=true&class=banner"
import script from "./VartaBlue.vue?vue&type=script&lang=js"
export * from "./VartaBlue.vue?vue&type=script&lang=js"

import "./VartaBlue.vue?vue&type=style&index=0&id=d120f2ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d120f2ce"]])

export default __exports__